// src/pages/admin/Dashboard.js

import React, { useEffect, useState } from 'react';
import { getDashboard, getTurmasBatismo, getTurmasNoivos } from '../../services/api';
import { formatDate } from '../../utils/helpers';

const StatCard = ({ icon, label, value, color = 'var(--navy)' }) => (
  <div style={{
    background: 'var(--white)',
    borderRadius: 'var(--radius-lg)',
    padding: '1.5rem',
    boxShadow: 'var(--shadow-sm)',
    borderTop: `4px solid ${color}`,
  }}>
    <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{icon}</div>
    <div style={{ fontSize: '2rem', fontWeight: 700, fontFamily: 'var(--font-display)', color }}>
      {value ?? '—'}
    </div>
    <div style={{ fontSize: '0.875rem', color: 'var(--gray-400)', marginTop: '0.25rem' }}>{label}</div>
  </div>
);

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [turmasBatismo, setTurmasBatismo] = useState([]);
  const [turmasNoivos, setTurmasNoivos] = useState([]);

  useEffect(() => {
    getDashboard().then(r => setStats(r?.data || {})).catch(() => {});
    getTurmasBatismo().then(r => setTurmasBatismo(r?.data || [])).catch(() => {});
    getTurmasNoivos().then(r => setTurmasNoivos(r?.data || [])).catch(() => {});
  }, []);

  const proximas = [...(turmasBatismo || []), ...(turmasNoivos || [])]
    .filter(t => new Date(t.dataInicio) >= new Date())
    .sort((a, b) => new Date(a.dataInicio) - new Date(b.dataInicio))
    .slice(0, 5);

  return (
    <div style={{ padding: '2rem' }}>
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}>Dashboard</h1>
        <p style={{ color: 'var(--gray-400)', fontSize: '0.875rem' }}>Visão geral do sistema paroquial</p>
      </div>

      {/* Stats */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '1rem',
        marginBottom: '2rem',
      }}>
        <StatCard icon="🕊" label="Inscrições de Batismo" value={stats?.batismo} color="var(--navy)" />
        <StatCard icon="💍" label="Inscrições de Noivos" value={stats?.noivos} color="var(--gold)" />
        <StatCard icon="📜" label="Solicitações" value={stats?.solicitacoes} color="#1a6fa0" />
        <StatCard icon="✅" label="Pendentes" value={stats?.pendentes} color="var(--warning)" />
      </div>

      {/* Próximas turmas */}
      <div style={{
        background: 'var(--white)',
        borderRadius: 'var(--radius-lg)',
        padding: '1.5rem',
        boxShadow: 'var(--shadow-sm)',
      }}>
        <h3 style={{ marginBottom: '1.25rem', fontSize: '1rem' }}>Próximas Turmas</h3>
        {proximas.length === 0 ? (
          <p style={{ color: 'var(--gray-400)', fontSize: '0.875rem' }}>Nenhuma turma futura cadastrada.</p>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Tipo</th>
                  <th>Início</th>
                </tr>
              </thead>
              <tbody>
                {proximas.map((t, i) => (
                  <tr key={i}>
                    <td>{t.nome}</td>
                    <td>
                      <span className="badge badge-pending">
                        {t.dataBatismo ? '🕊 Batismo' : '💍 Noivos'}
                      </span>
                    </td>
                    <td>{formatDate(t.dataInicio)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
